import { ColorSwatch, SelectionSetInput, SelectionSetLabel } from '@vp/swan'
import { ColorOptionProps } from '~/app/features/Gallery/components/Filters/ProductColor/interface'

export const ColorOption = ({ disabled, value, title, primaryColor }: ColorOptionProps) => (
  <SelectionSetInput disabled={disabled} value={value}>
    <SelectionSetLabel>
      <ColorSwatch aria-label={title} as="span" primaryColor={primaryColor} title={title}>
        {title && <span className="screen-reader-text">{title}</span>}
      </ColorSwatch>
    </SelectionSetLabel>
  </SelectionSetInput>
)
